import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'
import lookups from '@/assets/json/clientLookups.json'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const getIndivInfoByIdnNumOrUnNumFamilyMem = async ({ isUnifiedNumber } = actionParams) => {
  const formStore = useFormStore()
  const { familyMemUnNumber, familyMemIdnNumber } = formStore.form.values || {}
  const { femaleChildrenNaturalizationRequest } = lookups.ServiceTransactions
  const serviceTransactionId = router.currentRoute.value.params.serviceId

  if (familyMemUnNumber || (familyMemIdnNumber && familyMemIdnNumber.length >= 15)) {
    try {
      let IdentityNumberOrUnifiedNumber = isUnifiedNumber ? familyMemUnNumber : familyMemIdnNumber
      const params = {
        isUnifiedNumber,
        IdentityNumberOrUnifiedNumber,
        ServiceTransId: serviceTransactionId
      }

      const res = await apiHelperService.get(`/api/individual/usersInfoByIdnOrUnNumberFamilyMem`, {
        params
      })
      const { unifiedNumber, identityCardNumber, gender, localMaritalStatusId } = res
      formStore.form.setValues({
        familyMemUnNumber: unifiedNumber,
        familyMemIdnNumber: identityCardNumber
      })

      if (
        serviceTransactionId == femaleChildrenNaturalizationRequest &&
        gender == 1 &&
        localMaritalStatusId == 2
      ) {
        formStore.extraMap.showRequestNaturalizationForChildsFamily = true
      }
    } catch (error) {
      console.error('getIndivInfoByIdnNumOrUnNumFamilyMem', error)
      doNotify(
        i18n.global.t('personNumberIsWrongOrNotRelated'),
        i18n.global.t('personNumberIsWrongOrNotRelated')
      )

      formStore.form.setValues({
        familyMemUnNumber: '',
        familyMemIdnNumber: ''
      })
    }
  }
}

const getIndivInfoByIdnNumOrUnNumForChildsFamily = async ({ isUnifiedNumber } = actionParams) => {
  const formStore = useFormStore()
  const { childsFamilyUnifiedNumber, childsFamilyIdentityNumber } =
    formStore.form.values?.edit_requestNaturalizationForChildsFamily || {}
  const serviceTransactionId = router.currentRoute.value.params.serviceId
  if (
    childsFamilyUnifiedNumber ||
    (childsFamilyIdentityNumber && childsFamilyIdentityNumber.length >= 15)
  ) {
    try {
      let IdentityNumberOrUnifiedNumber = isUnifiedNumber
        ? childsFamilyUnifiedNumber
        : childsFamilyIdentityNumber
      const params = {
        isUnifiedNumber,
        IdentityNumberOrUnifiedNumber,
        ServiceTransId: serviceTransactionId
      }

      const res = await apiHelperService.get(
        `/api/individual/usersInfoByIdnOrUnNumberChildsFamily`,
        {
          params
        }
      )
      const { unifiedNumber, identityCardNumber } = res
      if (!isUnifiedNumber) {
        formStore.form.setFieldValue(
          'edit_requestNaturalizationForChildsFamily.childsFamilyUnifiedNumber',
          unifiedNumber
        )
      }
      formStore.form.setFieldValue(
        'edit_requestNaturalizationForChildsFamily.childsFamilyIdentityNumber',
        identityCardNumber
      )
    } catch (error) {
      console.error('getIndivInfoByIdnNumOrUnNumForChildsFamily', error)

      formStore.form.setFieldValue(
        'edit_requestNaturalizationForChildsFamily.childsFamilyUnifiedNumber',
        null
      )
      formStore.form.setFieldValue(
        'edit_requestNaturalizationForChildsFamily.childsFamilyIdentityNumber',
        null
      )
    }
  }
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'getIndivInfoByIdnNumOrUnNumFamilyMem':
      getIndivInfoByIdnNumOrUnNumFamilyMem(actionParams)
      break
    case 'getIndivInfoByIdnNumOrUnNumForChildsFamily':
      getIndivInfoByIdnNumOrUnNumForChildsFamily(actionParams)
      break
    default:
      break
  }
}
